import React, { useState } from 'react';
import { MdEmail } from 'react-icons/md';

import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { AssociationDto } from 'legacy/groups/types';

import StudentEmailForm from './components/StudentEmailForm';
import ConfirmCodeForm from './components/ConfirmCodeForm';
import { GoToStepFn, StepsId } from './types';

type EmailDomainModalProps = {
  onClose: () => void;
  emailDomains: string[];
  association: AssociationDto;
};

const STEPS = {
  [StepsId.StudentEmailStep]: StudentEmailForm,
  [StepsId.ConfirmCodeStep]: ConfirmCodeForm
};

const EmailDomainModal = ({
  onClose,
  emailDomains,
  association
}: EmailDomainModalProps) => {
  const [currentStep, setCurrentStep] = useState(StepsId.StudentEmailStep);

  // Retrieves the step component from the STEPS map.
  const StepComponent = STEPS[currentStep];

  const goToStep: GoToStepFn = (stepId) => {
    setCurrentStep(stepId);
  };

  return (
    <Modal
      visible
      type={ModalType.SMALL}
      autoHeight
      onClose={onClose}
      title="Student Email"
      icon={<MdEmail size={20} />}
    >
      <StepComponent
        goToStep={goToStep}
        emailDomains={emailDomains}
        association={association}
        onClose={onClose}
      />
    </Modal>
  );
};

export default EmailDomainModal;
